///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.workflows = abcsetup.workflows || {};
abcsetup.workflows.edit = abcsetup.workflows.edit || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.workflows.edit = {
    init: function() {
        abcsetup.setTitle('Edit Workflow');

        // Init history datatable
        abcsetup.datatables.client_side.init($('#history_table'), {
            'dom': 'x',
            'iDisplayLength': -1,
            'order': [[3, 'asc']],
            'responsive': false,
        });
    },
}
